import React from 'react';
  import Card from '@mui/material/Card';
 import CardContent from '@mui/material/CardContent';
import { useLocation } from 'react-router-dom';
 
 
const FaydaProfile = () => {
  const location = useLocation();
  const user = location.state?.user;
  if (!user) return <p>No Fayda profile data found. Please authenticate again.</p>;

  const { name, gender, birthdate, picture, address = {}, sub } = user;

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <Card className="w-full max-w-lg shadow-2xl rounded-2xl p-6 bg-white">
        <div className="flex justify-center mb-4">
          {picture && (
            <img
              src={picture}
              alt="Fayda ID User"
              className="w-32 h-32 rounded-full object-cover border-4 border-blue-500 shadow"
            />
          )}
        </div>
        <CardContent className="space-y-4 text-center">
          <h2 className="text-xl font-semibold">Fayda ID Profile</h2>

          <div className="text-left space-y-2">
            <p><strong>Name:</strong> {name}</p>
            <p><strong>Gender:</strong> {gender}</p>
            <p><strong>Birthdate:</strong> {birthdate}</p>
            <p><strong>Fayda ID (sub):</strong> {sub}</p>
            {address && (
              <div>
                <p className="font-medium">Address:</p>
                <ul className="list-disc ml-5">
                  {address.region && <li><strong>Region:</strong> {address.region}</li>}
                  {address.zone && <li><strong>Zone:</strong> {address.zone}</li>}
                  {address.woreda && <li><strong>Woreda:</strong> {address.woreda}</li>}
                  {address.kebele && <li><strong>Kebele:</strong> {address.kebele}</li>}
                </ul>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default FaydaProfile;
